import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import wastebasketIcon from '../../asset/img/previous_wastebasket_icon.svg';
import pencilIcon from '../../asset/img/common/pencil_icon.svg';

import RadioOptionGroup from '../../components/common/RadioOptionGroup';
import { dependentsOptions, relationOptions } from '../../common/data';
import Typography from '../../components/common/Typography';
import Chips from '../../components/common/Chips';
import { IconButton } from '../../components/common/Button';

import {
  getDependentsInfo,
  getPreviousDependentsInfo,
  handleDependentsInfo,
  resetDependentsState,
  setSelectedDependents,
  updateDependentsInfo,
} from './dependentsSlice';
import {
  getDeleteDialogConfig,
  getDialogConfig,
  magamCertifyCheck,
  nameRelation,
  setRegNumber,
} from '../../common/Util';
import { checkValidity } from './util';

// 이름 : v.htm038
// 관계 : familyCode[v.htm002]
// 주민등록번호 : v.htm001
// htmYy : 년도
// htm002 : 0:본인, 1:소득자직계존속, 2:배우자직계존속, 3:배우자, 4:직계비속, 5:형제자매, 6:위탁아동, 7 : 기타
// htm003 : 기본공제 1yes,2no
// htm004 : 장애인 1yes,2no
// htm005 : 부녀자 1yes,2no
// htm008 : 출산 1yes,2no
// htm032 : 1.내국,9외국
// htm036 : (다자녀 1번만 해당) 자녀구분 1:자녀 , 2:손자손녀, 3:사위, 4:며느리
// htm039 : 경로우대 1yes,2no
// htm040 : 세대주
// htm041 : 기초수급
// htm058 : 입양 1yes,2no
// htm074 : 소득금액 100만원이하 1:예 2: 아니오
// htm080 : 한부모유무 1yes,2no

const DependentsInfoCard = ({
  handleOpen,
  openSlideDialog,
  openSlideDialog2,
  openSlideDialog3,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation('dependents');
  const { t: tCommon } = useTranslation('common');

  const options = dependentsOptions(t);
  const relationList = relationOptions(t);
  const { isMagam, isCertify } = useSelector(state => state.common);
  const { dataList, reload, isRender, nonItemList, selectedDependents, htmBoyangFlag } =
    useSelector(state => state.dependents);

  // 상태 추가
  const [optionStates, setOptionStates] = useState({
    htm004List: new Array(dataList?.length || 0).fill(false),
    htm008List: new Array(dataList?.length || 0).fill(false),
    htm058List: new Array(dataList?.length || 0).fill(false),
    htm040List: new Array(dataList?.length || 0).fill(false),
  });

  // dataList가 변경될 때마다 상태 배열 길이 업데이트
  useEffect(() => {
    setOptionStates({
      htm004List: dataList.map(item => item.htm004 === '1'),
      htm008List: dataList.map(item => item.htm008 === '1'),
      htm058List: dataList.map(item => item.htm058 === '1'),
      htm040List: dataList.map(item => item.htm040 === '1' || item.htm040 === '3'),
    });
  }, [dataList]);

  //초기 데이터 호출
  useEffect(() => {
    dispatch(getDependentsInfo());
  }, []);

  //저장, 삭제시 재호출
  useEffect(() => {
    if (reload != -1) {
      dispatch(getDependentsInfo());
    }
  }, [reload]);

  //언마운트시 초기화
  useEffect(() => {
    return () => {
      dispatch(resetDependentsState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (htmBoyangFlag && htmBoyangFlag == '1') {
      const message = getDialogConfig(
        tCommon,
        'getPreviousDependents',
        'dependents',
        'GET_PREVIOUS_DEPENDENTS',
      );

      dispatch(message);
    }
  }, [htmBoyangFlag]);

  useEffect(() => {
    console.log('selectedDependents >>', selectedDependents);
    if (selectedDependents?.htm001) {
      handleOpen();
    }
  }, [selectedDependents, dispatch]);

  //장애인, 출산, 입양 체크용
  useEffect(() => {
    // htm081이 1보다 크면 htm004도 체크되도록 처리
    dataList.forEach((data, index) => {
      if (data.htm081 > '1' && data.htm004 !== '1') {
        dispatch(
          updateDependentsInfo({
            htm001: data.htm001,
            m_id: 'htm004',
            m_value: '1',
          }),
        );
      }

      if (data.htm081 < '1' && data.htm004 == '1') {
        dispatch(
          updateDependentsInfo({
            htm001: data.htm001,
            m_id: 'htm004',
            m_value: '2',
          }),
        );
      }
    });
  }, [dataList]);

  const handleChange = (index, key, value, parentKey) => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }
    let isValidate = checkValidity(dataList, index, key, value, t, parentKey);
    if (!isValidate) return;

    //소득공제 100만원 이하 확인팝업
    if (key == 'htm074' && value == '1') {
      openSlideDialog(dataList[index]);
      return;
    }

    //결혼세액공제 팝업
    if (key == 'htm158' && value == '1') {
      openSlideDialog2(dataList[index]);
      return;
    }

    // htm004(장애인) 체크 해제될 때
    if (key === 'htm004' && value == '2') {
      // htm081도 초기화하고 옵션을 닫음
      dispatch(
        updateDependentsInfo({
          htm001: dataList[index].htm001,
          m_id: 'htm081',
          m_value: '',
        }),
      );

      return;
    }

    // htm040(세대주) 체크 해제될 때
    if (key === 'htm040' && value == '2') {
      dispatch(
        updateDependentsInfo({
          htm001: dataList[index].htm001,
          m_id: 'htm040',
          m_value: '2',
        }),
      );

      // 옵션 상태도 닫기
      setOptionStates(prev => ({
        ...prev,
        htm040List: prev.htm040List.map((v, i) => (i === index ? false : v)),
      }));

      return;
    }

    // 출산 또는 입양 해제 시
    if ((key === 'htm008' || key === 'htm058') && value == '2') {
      // dispatch(
      //   updateDependentsInfo({
      //     htm001: dataList[index].htm001,
      //     m_id: 'htm109',
      //     m_value: '0',
      //   }),
      // );

      // 해당 옵션 상태도 닫기
      setOptionStates(prev => ({
        ...prev,
        [`${key}List`]: prev[`${key}List`].map((value, i) => (i === index ? false : value)),
      }));
    }
    // htm081 옵션(장애인 상세)이 선택되면 htm004도 체크
    if (key === 'htm081' && value > '0') {
      if (value <= '2') {
        openSlideDialog3({ htm001: dataList[index].htm001, value: value });
        return;
      }

      dispatch(
        updateDependentsInfo({
          htm001: dataList[index].htm001,
          m_id: 'htm004',
          m_value: '1',
        }),
      );
    }

    //htm109 자녀체크이 선택되면 출생or 입양 체크
    if (key === 'htm109') {
      dispatch(
        updateDependentsInfo({
          htm001: dataList[index].htm001,
          m_id: key,
          m_value: value,
          m_sub_id: parentKey,
        }),
      );

      return;
    }

    dispatch(
      updateDependentsInfo({
        htm001: dataList[index].htm001,
        m_id: key,
        m_value: value,
      }),
    );
  };

  const handleDelete = index => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    //삭제 하시겠~~~?
    dispatch(
      getDeleteDialogConfig(tCommon, 'dependents', {
        formData: [{ htm001: dataList[index].htm001 }],
      }),
    );
  };

  const handleDetail = htm001 => {
    console.log('handleDetail >>', htm001);
    dispatch(setSelectedDependents({ htm001: htm001?.trim() }));
  };

  const handleOptionGroupClick = (index, key) => {
    if (key === 'htm004' || key === 'htm008' || key === 'htm058' || key === 'htm040') {
      setOptionStates(prev => ({
        ...prev,
        [`${key}List`]: prev[`${key}List`].map(
          (value, i) => (i === index ? !value : value), // 토글 기능으로 변경
        ),
      }));
    }
  };

  const optionChecked = (data, option) => {
    //출생, 입양 옵션일때 출생 또는 입양에 이미 체크된 자녀가 있으면 체크 푼다
    if (option.optionKey == 'htm109') {
      if (data[option.key] != '1') return '0';
    }
    return data[option.optionKey];
  };

  const htm109Duplicated = (data, option, optionKey) => {
    if (optionKey != 'htm109') return false;

    let filter = dataList.filter(
      item => data.htm001 != item.htm001 && item.htm109 === option.value,
    );
    console.log('filter> >', filter);
    return dataList.some(
      item =>
        data.htm001 != item.htm001 &&
        (item.htm058 == '1' || item.htm008 == '1') &&
        item.htm109 === option.value,
    );
  };

  return (
    <div className="dependentsInfoCard">
      {dataList.map((data, index) => {
        const hiddenKeys = nonItemList[index] || [];

        const filteredOptions = options.filter(option => !hiddenKeys.includes(option.key));
        const isDisabledList = options.filter(option => hiddenKeys.includes(option.key));
        return (
          <div key={index} className="dependentsInfoCardItem">
            <div className="dependentsInfoCardItemTop">
              <div className="displayFlex" style={{ justifyContent: 'space-between' }}>
                <div>
                  <Typography variant="body2Bold">{nameRelation(t, data)}</Typography>
                  <Typography variant="captionMedium">{setRegNumber(data?.htm001)}</Typography>
                </div>
                {data?.htm002 != '0' && (
                  <div className="displayFlex" style={{ gap: '10px' }}>
                    {/* 수정 */}
                    <IconButton
                      imgSrc={pencilIcon}
                      variant="outline"
                      size="small"
                      color="gray"
                      onClick={() => handleDetail(data?.htm001)}
                    />
                    {/* 삭제 */}
                    <IconButton
                      imgSrc={wastebasketIcon}
                      variant="outline"
                      size="small"
                      color="gray"
                      onClick={() => handleDelete(index)}
                    />
                  </div>
                )}
              </div>
              {filteredOptions.map((option, idx) => (
                <RadioOptionGroup
                  key={idx}
                  label={option.label}
                  options={option.option}
                  optionChecked={optionChecked(data, option)}
                  checked={
                    option.key === 'htm040'
                      ? data[option.key] === '1' || data[option.key] === '3'
                      : data[option.key] === '1'
                  }
                  isDisabled={
                    (option.key === 'htm003' && data.htm002 == '0') ||
                    (option.key === 'htm040' && data.htm002 != '0')
                  }
                  htm109Duplicated={_option => htm109Duplicated(data, _option, option.optionKey)}
                  isOpen={
                    option.key === 'htm004'
                      ? optionStates.htm004List[index]
                      : option.key === 'htm008'
                      ? optionStates.htm008List[index]
                      : option.key === 'htm058'
                      ? optionStates.htm058List[index]
                      : option.key === 'htm040'
                      ? optionStates.htm040List[index]
                      : undefined
                  }
                  onChange={() => {
                    if (
                      (option.key == 'htm003' && data.htm002 == '0') ||
                      (option.key == 'htm040' && data.htm002 != '0')
                    ) {
                      return;
                    }

                    if (
                      option.key === 'htm004' ||
                      option.key === 'htm008' ||
                      option.key === 'htm058' ||
                      option.key === 'htm040'
                    ) {
                      // htm040은 '1' 또는 '3'일 때 체크 상태
                      if (option.key === 'htm040') {
                        if (data[option.key] === '1' || data[option.key] === '3') {
                          handleChange(index, option.key, '2');
                        } else {
                          handleOptionGroupClick(index, option.key);
                        }
                      } else {
                        // htm004, htm008, htm058은 '1'일 때 체크 상태
                        if (data[option.key] === '1') {
                          handleChange(index, option.key, '2');
                        } else {
                          handleOptionGroupClick(index, option.key);
                        }
                      }
                    } else {
                      handleChange(index, option.key, data[option.key] == '1' ? '2' : '1');
                    }
                  }}
                  onOptionChange={e =>
                    handleChange(index, option.optionKey, e.target.value, option.key)
                  }
                />
              ))}
            </div>
            <div className="dependentsInfoCardItemLine"></div>
            <div className="dependentsInfoCardItemBottom">
              <Chips color="error">{t('selectList.chips')}</Chips>
              <Typography variant="captionMedium">
                {isDisabledList.map(option => option.label).join(', ')}
              </Typography>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DependentsInfoCard;
